<template>
  <div>
    <div class="image-uploader">
      <div v-if="!imagePreview" class="upload-container">
        <vue-dropzone id="image-dzone" ref="imageDropZone" :use-custom-slot="true" :options="dzoneOptions" @vdropzone-file-added="handleFileSelected">
          <div class="dropzone-custom-content" style="color: black">
            <i class="uil uil-upload" />
            <div class="font-size-15">Drag and drop your image here</div>
            <div class="small my-2 font-size-12">or</div>
            <b-btn type="button" class="btn-dark-blue">Browse Files</b-btn>
            <div class="font-size-12 mt-4">Supports: JPG, PNG, GIF (Max: 5MB)</div>
          </div>
        </vue-dropzone>
      </div>
      <div v-else class="preview-container">
        <div class="preview-wrapper">
          <img :src="imagePreview" alt="Preview" class="img-preview" />
        </div>
      </div>
    </div>
    <div v-if="imagePreview">
      <div class="justify-content-start mt-3 button-group">
        <b-button size="md" variant="outline-primary" class="mr-2" @click="openCropModal" @imageCropped="updateImage">
          <i class="uil uil-crop-alt mr-1"></i> Crop to Square
        </b-button>
        <b-button size="md" variant="outline-dark" class="mr-2" @click="resetImage">
          <i class="uil uil-refresh mr-1"></i> Replace
        </b-button>
      </div>
    </div>
    <!-- Crop Modal -->
    <crop-modal
        ref="cropModal"
      :visible="showCropModal"
      :image="imagePreview"
      :on-close="closeCropModal"
      @imageCropped="handleCropComplete"
    />
  </div>
</template>

<script>
import CropModal from './CropModal.vue';
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import {mapMutations} from "vuex";

export default {
  name: 'SimpleImageUploader',
  components: {
    CropModal,
    vueDropzone: vue2Dropzone
  },
  props: {
    initialImage: {
      type: String,
      default: ''
    },
    imageId:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedFile: null,
      imagePreview: this.initialImage,
      showCropModal: false,
      dzoneOptions:{
        url:'localhost',
        thumbnailWidth: 0,
        maxFilesize: 5000000,
        createImageThumbnails: false,
        acceptedFiles:'image/*',
      }
    };
  },
  watch: {
    initialImage(newVal) {
      if (newVal) {
        this.imagePreview = newVal;
      }
    }
  },
  mounted() {
    // Auto-show crop modal when a new image is uploaded
    /* if (this.imagePreview && !this.imageId) {
      this.$nextTick(() => {
        this.showCropModal = true;
      });
    } */
  },
  methods: {
    ...mapMutations('imageEditor', ['UPDATE_CROP_MODAL_VISIBILITY']),
    selectImage(){
      this.$refs.fileInput.$el.click()
    },
    handleFileSelected(file) {
      if (!file) return;

      const reader = new FileReader();
      reader.onload = e => {
        this.imagePreview = e.target.result;
        this.$emit('image-selected', file, e.target.result);
        this.UPDATE_CROP_MODAL_VISIBILITY(true);
      };
      reader.readAsDataURL(file);
    },
    resetImage() {
      this.selectedFile = null;
      this.imagePreview = null;
      this.$emit('image-reset');
    },
    removeImage() {
      this.resetImage();
    },
    openCropModal() {
      this.UPDATE_CROP_MODAL_VISIBILITY(true)
    },
    updateImage(image){
      this.$emit('image-selected', image);
    },
    closeCropModal() {
      this.UPDATE_CROP_MODAL_VISIBILITY(false);
    },
    handleCropComplete(cropImage) {
      this.imagePreview = cropImage;
      this.$emit('image-selected', cropImage);
    }
  }
};
</script>
<style lang="scss">
  #app.business-image-editor{
    .vue-dropzone .dz-message{
      margin: 0 !important;
    }
  }
</style>
<style scoped>
.preview-container {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
}
.preview-wrapper {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
  display: inline-block;
}
.img-preview {
  max-width: 100%;
  max-height: 125px;
  border-radius: 4px;
  display: block;
}
.image-overlay-dotted {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px dotted rgba(0, 123, 255, 0.5);
  pointer-events: none;
}
.button-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.button-group .btn {
  margin-bottom: 0.5rem;
}
</style>
